import { useState, useEffect, type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { Alert } from 'shared/ui'
import { TrialBroadcastLimitAlertStore } from 'entities/Subscription/ui/TrialBroadcastLimitAlert/store/trialBroadcastLimitAlertStore'
import { useEntitiesContext } from 'entities/EntitiesExport'

type ITrialBroadcastLimitAlertProps = {
  onCloseModal?: () => void
}

export const TrialBroadcastLimitAlert: FC<ITrialBroadcastLimitAlertProps> = observer(
  ({ onCloseModal }) => {
    const entities = useEntitiesContext()
    const [store] = useState(
      () =>
        new TrialBroadcastLimitAlertStore(entities, {
          onCloseModal: onCloseModal,
        })
    )

    useEffect(() => {
      store.init()
    }, [])

    if (store.hide) return null

    return <Alert {...store.configAlert} />
  }
)
